import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import TableWithExtractSearchLayout from "../../../../../common/Layout/table-with-extract-search/table-with-extract-search.layout";
import CrudTable from "../../../../../common/details-table/crud-table.component";
import { Button } from "react-bootstrap";
import { NotificationModal } from "../../../../../common/modal/notification-modal.component";
import { CONFIRMATION_VALUE, TRANSLATIONS as translation } from "../../../../../../utils/constant.utils";
import { MODAL_CUSTOM_MESSAGE, UPLOAD_TYPES } from "../../../../../../constants/external-constants";
import { ConfirmationNotificationModal } from "../../../../../common/modal/confirmation-modal.component";
import { NoSubscription } from "../../../../dashboard/no-subscription/no-subscription.component";
import { outputConfigRechargeItemsActions } from "../../../../../../store/external/recharge-reducer/output-configuration-reducer/output-configuration-recharge-items.reducer";

class RechargeItems extends Component {
    constructor(props) {
        super(props);
        this.state={
            dataTable: [],
            headerTable:[],
            fieldType:[],
            enableSearch:false,
            isProcessing: false,
            showModal: false,
            pendingAction: '',
            confirmationMessage: "",
            selectedRows: [],
            unselectedRows: [],
            updatedRows: [],
            allRowKeys: [],
            isLoading: true,
            isSearchTriggered: false,
            initialRowKeysCount: 0,
            outputRecordID: '',
            exportAlertMsg: MODAL_CUSTOM_MESSAGE.export_alert_message,
            saveNotif: {
                show: false,
                title: "",
                message: ""
            },
            extractOption: [
                { id: 0, label: "Extract List" },
                { id: 1, label: "Output Record Preview" }
            ]
        };
    }

    async componentDidMount() {
        const { outputConfigurationId } = this.props;

        try {
            await this.props.getOutputConfigRechargeItems(outputConfigurationId);
            const allKeys = await this.props.getAllOutputConfigRechargeItemKeys(outputConfigurationId);
            const outputRecordId = await this.props.getLatestInProgressOutputRecordName(outputConfigurationId);

            this.setState({
                allRowKeys: allKeys,
                unselectedRows: [],
                outputRecordID: outputRecordId,
                initialRowKeysCount: allKeys.length,
                isProcessing: Boolean(outputRecordId) && allKeys.length === 0,
                isLoading: false
            }, () => {
                this.updateSelectedRows(allKeys, []);
            });
        } catch (error) {
            console.error("Failed to load data", error);
            this.setState({ isLoading: false }); 
        }
    }

    async componentDidUpdate(prevProps) {
        const { outputConfigRechargeItems, outputConfigurationId } = this.props;

        if (
            prevProps.outputConfigRechargeItems !== outputConfigRechargeItems &&
            outputConfigRechargeItems
        ) {
            this.initializeData(outputConfigRechargeItems);

            if (this.state.isSearchTriggered) {
                try {
                    const allKeys = await this.props.getAllOutputConfigRechargeItemKeys(outputConfigurationId);

                    this.setState({
                        allRowKeys: allKeys,
                        unselectedRows: [],
                        isSearchTriggered: false
                    }, () => {
                        this.updateSelectedRows(allKeys, []);
                    });
                } catch (error) {
                    console.error("Failed to fetch updated keys", error);
                    this.setState({ isSearchTriggered: false });
                }
            }
        }
    }

    componentWillUnmount() {
        this.props.setDefaultConfigRechargeItems();
    }

    initializeData = (data) => {
        const dataHeader = data?.configRechargeItemsItems?.Headers;
        const rawDataItem = data?.configRechargeItemsItems?.Data?.Items;

        const dataItem = Array.isArray(rawDataItem)
            ? rawDataItem.map(({ DynamicColumns, ...rest }) => ({
                ...rest,
                ...DynamicColumns
            }))
            : [];

        const newState = {
            dataTable: dataItem
        };

        if (dataHeader) {
            const numberFields = ['RechargingQuantity', 'RechargingAmount'];
            const dateFields = ['Date', 'ServiceDate', 'CreationDate'];

            newState.headerTable = [dataHeader];

            newState.fieldType = Object.keys(dataHeader)
                .filter(key => key !== 'Key')
                .map(key => ({
                    name: key,
                    type: numberFields.includes(key) ? 'number' : dateFields.includes(key) ? 'date' : 'text',
                    required: false
                }));
        }

        this.setState(newState);
    };

    toLocaleLanguage = (key, isCapitalize = true) => {
        const { locale } = this.props;
        const lang = translation[locale] || translation[translation['defaultLocaleLanguage']];
        if (!lang || !lang[key]) return key;
        return isCapitalize ? lang[key].toUpperCase() : lang[key];
    };

    handleCheckboxChange = (itemKey) => {
        this.setState(prevState => {
            const isUnselected = prevState.unselectedRows.includes(itemKey);
            const newUnselectedRows = isUnselected
                ? prevState.unselectedRows.filter(key => key !== itemKey)
                : [...prevState.unselectedRows, itemKey];

            return {
                unselectedRows: newUnselectedRows
            };
        }, () => {
            this.updateSelectedRows(this.state.allRowKeys, this.state.unselectedRows);
        });
    };

    handleSelectAllChange = () => {
        const { allRowKeys, unselectedRows } = this.state;
        const allSelected = unselectedRows.length === 0;

        const newUnselectedRows = allSelected ? [...allRowKeys] : [];

        this.setState({
            unselectedRows: newUnselectedRows
        }, () => {
            this.updateSelectedRows(this.state.allRowKeys, newUnselectedRows);
        });
    };

    getSelectedRows = () => {
        return this.state.allRowKeys.filter(key => !this.state.unselectedRows.includes(key));
    };

    handleTableValidation = (key, updatedData) => {
        const invalidFields = [];
        const row = updatedData.find(item => item.Key === key);

        for (const columnName in row) {
            if (columnName.toLowerCase().includes('date')) {
                const val = row[columnName];

                if (!val) continue;

                if (isNaN(Date.parse(val))) {
                    invalidFields.push(columnName);
                }
            }
        }

        if (invalidFields.length > 0) {
            this.setState(prev => ({
                saveNotif: {
                    show: true,
                    title: "Invalid Date",
                    message: "Please correct the entry to match a valid date format",
                }
            }));
        }

        return invalidFields.length > 0 ? invalidFields : null;
    };

    handleDeleteData = async (key) => {
        const { outputConfigurationId, deleteOutputConfigRechargeItems, outputConfigRechargeItems } = this.props;
        const currentPageIndex = outputConfigRechargeItems?.configRechargeItemsItems?.Data?.PageIndex;
        const validate = 0;
        try {
            await deleteOutputConfigRechargeItems(outputConfigurationId, key, validate, currentPageIndex);

            this.setState(prev => ({
                dataTable: prev.dataTable.filter(item => item.Key !== key),
                updatedRows: prev.updatedRows.filter(k => k !== key),
                initialRowKeysCount: prev.initialRowKeysCount - 1,
                saveNotif: {
                show: true,
                title: "Deleted",
                message: "Selected recharge item deleted."
            }
            }));
        } catch (err) {
            this.setState({
                saveNotif: {
                    show: true,
                    title: "Error",
                    message: "Failed to delete the recharge item."
                }
            });
        }
    };

    updateData = async (key, newData) => {
        const { outputConfigurationId, updateOutputConfigRechargeItems, outputConfigRechargeItems } = this.props;
        const currentPageIndex = outputConfigRechargeItems?.configRechargeItemsItems?.Data?.PageIndex;

        let updatedItem = null;

        this.setState(prevState => {
            const updated = newData;
            const index = updated.findIndex(item => item.Key === key);

            if (index !== -1) {
                const flatRow = updated[index];

                // List of known fixed fields
                const fixedFields = [
                    "Key", "RechargingOutputRecordStagingID", "RechargingOutputConfigurationID", "RechargingOutputRecordID",
                    "FeederSystem", "RechargingInventoryType", "DDI", "Type", "Vendor", "Date", "EndUser", "Requestor",
                    "RechargingPerson", "RechargingQuantity", "RechargingAmount", "ServiceInstanceID", "CustomerTag",
                    "ArticleNumber", "ArticleName", "DebitorNumber", "DebitorName", "CostCenter", "SalesOrganizationNumber",
                    "VATGroup", "PriceCalculation", "AdditionalAttribute", "ServiceDate", "InvoiceNumber", "LineItemID",
                    "Currency", "LocationID", "CreationDate", "CreatedBy", "State", "CreatedByUserID", "CreatedDate",
                    "ModifiedByUserID", "ModifiedDate"
                ];

                const DynamicColumns = {};
                const cleanedRow = {};

                // Split fixed fields and dynamic columns
                for (const k in flatRow) {
                    if (fixedFields.includes(k)) {
                        cleanedRow[k] = flatRow[k];
                    } else {
                        DynamicColumns[k] = flatRow[k] != null ? String(flatRow[k]) : "";
                    }
                }

                // Ensure formatting for decimals (5 decimals, safe fallback to "0.00000")
                cleanedRow.RechargingQuantity = cleanedRow.RechargingQuantity != null
                    ? Number(cleanedRow.RechargingQuantity).toFixed(5)
                    : "0.00000";

                cleanedRow.RechargingAmount = cleanedRow.RechargingAmount != null
                    ? Number(cleanedRow.RechargingAmount).toFixed(5)
                    : "0.00000";

                updatedItem = {
                    ...cleanedRow,
                    DynamicColumns
                };

                updated[index] = { ...updatedItem, ...DynamicColumns };
            }

            return {
                dataTable: updated,
                selectedRows: [...new Set([...prevState.selectedRows, key])],
                pendingAction: "update",
                updatedRows: [key]
            };
        }, async () => {
            try {
                if (!updatedItem) throw new Error("No item to update.");

                const stagingId = key;
                const validate = 0;

                await updateOutputConfigRechargeItems(
                    outputConfigurationId,
                    stagingId,
                    validate,
                    [updatedItem],
                    currentPageIndex
                );

                this.setState({
                    updatedRows: [],
                    saveNotif: {
                        show: true,
                        title: "Updated",
                        message: "Selected recharge item updated."
                    }
                });
            } catch (err) {
                this.setState({
                    saveNotif: {
                        show: true,
                        title: "Error",
                        message: "Failed to update the recharge item."
                    }
                });
            }
        });
    };

    handleClearOutputRecord = () => {
        this.setState({
            showModal: true,
            confirmationMessage: MODAL_CUSTOM_MESSAGE.clear_output_record,
            pendingAction: "clear"
        });
    };

    onColumnSortConfigOutputRecord = (columnClicked, isSortedAsc) => {
        const { outputConfigurationId, sortConfigRechargeItemsItems } = this.props;
        sortConfigRechargeItemsItems(columnClicked, isSortedAsc, outputConfigurationId);
    };

    handleGenerateOutputRecord = async () => {
        this.setState({
            showModal: true,
            confirmationMessage: MODAL_CUSTOM_MESSAGE.output_record_notification,
            pendingAction: 'generate'
        });
    };

    handleGenerateOutputRecordSuccess = () => {

    }

    toggleSaveNotif = (isShow, title, message) => {
        const { saveNotif } = this.state;

        this.setState({
            saveNotif: {
                ...saveNotif,
                show: isShow,
                title: title ?? "",
                message: message ?? "",
            },
            showModal: false,
            pendingAction: '',
        });

        if (!isShow) {
            this.handleCloseForm?.();
        }
    };

    handleCloseForm = () => {
        this.setState({
            showModal: false,
            pendingAction: '',
            confirmationMessage: '',
        });
    };

    handleConfirmationModal = async (buttonType) => {
        const { pendingAction, selectedRows } = this.state;
        const { outputConfigurationId, 
                clearOutputConfigRechargeItems, 
                outputConfigRechargeItems,
                performCommitOutputRecord,            
                getInProgressOutputRecordId,
                fileFormatId,
                fileName,
                fileDelimeter,
                isGenerateJsonFile
            } = this.props;
        const currentPageIndex = outputConfigRechargeItems?.configRechargeItemsItems?.Data?.PageIndex;
        const validate = 0;
        

        if (buttonType === CONFIRMATION_VALUE.Ok) {
            try {
                if (pendingAction === 'clear') {
                    const clearedCount = selectedRows.length;
                    await clearOutputConfigRechargeItems(outputConfigurationId, validate, selectedRows, currentPageIndex);
                    this.setState(prev => ({
                        dataTable: prev.dataTable.filter(item => !selectedRows.includes(item.Key)),
                        selectedRows: [],
                        initialRowKeysCount: prev.initialRowKeysCount - clearedCount,
                    }));

                    this.toggleSaveNotif(true, "Cleared", "Selected recharge items cleared.");
                }

                if (pendingAction === 'generate') {
                    
                    try {
                            const outputRecordPrimaryKey = await getInProgressOutputRecordId(outputConfigurationId);

                            this.setState({
                                showModal: true,
                                confirmationMessage: MODAL_CUSTOM_MESSAGE.output_record_notification,
                                pendingAction: 'generate',
                                isProcessing: true
                            });

                            await performCommitOutputRecord(
                                outputConfigurationId,
                                outputRecordPrimaryKey,
                                UPLOAD_TYPES.RechargingOutputRecordGeneration,
                                fileFormatId,
                                fileName,
                                fileDelimeter,
                                isGenerateJsonFile);

                            await this.props.getOutputConfigRechargeItems(outputConfigurationId);
                            await this.props.getAllOutputConfigRechargeItemKeys(outputConfigurationId);
                            await this.props.getLatestInProgressOutputRecordName(outputConfigurationId);

                             this.toggleSaveNotif(true, "Notification", MODAL_CUSTOM_MESSAGE.output_record_generate_record);

                        } catch (error) {
                            console.error("Error in handleGenerateOutputRecord:", error);
                        }
                }
            } catch (err) {
                this.toggleSaveNotif(true, "Error", `Failed to ${pendingAction} selected items.`);
            }
        }
        else {
            this.setState({
                showModal: false,
                pendingAction: '',
            });
        }
    };

    paginationAction = (index) => {
        const { outputConfigurationId, getOutputConfigRechargeItems } = this.props;
        getOutputConfigRechargeItems(outputConfigurationId, index);
    };

    resizePage = (value) => {
        const { getOutputConfigRechargeItems, resizeConfigRechargeItemsPage, outputConfigurationId } = this.props;
        resizeConfigRechargeItemsPage(value);
        getOutputConfigRechargeItems(outputConfigurationId);
    };

    displaySearchBox = (value) => {
        this.setState({ enableSearch: value });
    };

    loading = () => {
        return (
            <NoSubscription />
        );
    };

    updateSelectedRows = (allRowKeys, unselectedRows) => {
        const selectedRows = allRowKeys.filter(key => !unselectedRows.includes(key));
        this.setState({ selectedRows });
    };

    handleOptionClick = (id) => {
        const { outputConfigurationId } = this.props;
        const { outputRecordID, exportAlertMsg } = this.state;

        if (window.confirm(exportAlertMsg)) {
            this.props.extractConfigRechargeItems(outputConfigurationId, outputRecordID, id);
        }
    };

    render() {
        const { isReadOnly, isReadAndExtractOnly, isReadAndWrite, outputConfigurationId, outputConfigRechargeItems, getOutputConfigRechargeItems, setConfigRechargeItemsColSearchStr } = this.props;
        const { headerTable, dataTable, enableSearch, fieldType, isProcessing, confirmationMessage, selectedRows, unselectedRows, extractOption, isLoading, initialRowKeysCount } = this.state;
        return (
            <div>
                <TableWithExtractSearchLayout
                    displaySearchBox={this.displaySearchBox}
                    isReadOnly={isReadOnly}
                    isReadAndExtractOnly={isReadAndExtractOnly}
                    isReadAndWrite={isReadAndWrite}
                    hideCustomColumn={true}
                    multipleOption={true}
                    extractListLabel="Extract List"
                    options={extractOption}
                    isViewing={isProcessing}
                    onSelect={this.handleOptionClick}
                >
                    {isProcessing && (
                        <span className="text-danger fw-bold fs-6">
                            Recharging for this specific configuration is currently in-progress
                        </span>
                    )}
                    {isLoading ? this.loading() :
                        <CrudTable
                            dataTable={dataTable}
                            headerTable={headerTable}
                            onColumnSearch={() => getOutputConfigRechargeItems(outputConfigurationId)}
                            onColumnSearchChange={(column, value) => {
                                setConfigRechargeItemsColSearchStr(column, value);
                                this.setState({ isSearchTriggered: true }, () => {
                                    getOutputConfigRechargeItems(outputConfigurationId);
                                });
                            }}
                            isColSearchShow={enableSearch}
                            isFiveDecimal={true}
                            pageList={outputConfigRechargeItems?.configRechargeItemsItems?.Data}
                            totalCount={outputConfigRechargeItems?.configRechargeItemsItems?.Data?.TotalCount}
                            pages={outputConfigRechargeItems?.configRechargeItemsItems?.Pagination}
                            paginationAction={this.paginationAction}
                            resizePage={this.resizePage}
                            onColumnClick={this.onColumnSortConfigOutputRecord}
                            fieldType={fieldType}
                            updateData={this.updateData}
                            handleDeleteData={this.handleDeleteData}
                            isDecisionModal={true}
                            customeDeleteMessage={MODAL_CUSTOM_MESSAGE.output_record_delete}
                            fetchDropdownValue={() => { }}
                            customValidation={this.handleTableValidation}
                            haveDeleteAndEditBtn={isReadAndWrite ? true : false}
                            havePagination={true}
                            hasColumSort={true}
                            unselectedRows={unselectedRows}
                            hasCheckBox={isReadAndWrite ? true : false }
                            selectedRows={selectedRows}
                            onCheckboxChange={this.handleCheckboxChange}
                            onSelectAllChange={this.handleSelectAllChange}                       
                            hasScroll={true}     
                        />
                    }
                </TableWithExtractSearchLayout>

                <div className="button-container d-flex align-items-center">
                    { isReadAndWrite &&
                        <div className="create-output">
                            <div className="tooltip-container">
                                <div className="btn-tooltiptext">
                                    <Button
                                        className='create-output-btn btn btn-danger rounded-5'
                                        disabled={selectedRows?.length === 0 || isProcessing}
                                        onClick={this.handleClearOutputRecord}
                                        type="button"
                                    >
                                        Clear Recharge Items
                                    </Button>
                                    <div>
                                        <span className="tooltip-text-save start-50 translate-middle-x top--50">
                                            {this.toLocaleLanguage("clear_output_record", false)}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    <div className='save-btn-container'>
                        <ConfirmationNotificationModal
                            show={this.state.showModal}
                            message={confirmationMessage}
                            isSaving={isProcessing}
                            disabled={isProcessing}
                            isDecisionModal={true}
                            title={'Notification'}
                            handleModal={this.handleConfirmationModal}
                            customClass={'comment-notification-modal modal-text-bold'}
                        />

                        <NotificationModal
                            show={this.state.saveNotif.show}
                            title={this.state.saveNotif.title}
                            message={this.state.saveNotif.message}
                            handleModal={() => this.toggleSaveNotif(false)}
                            customClass={'comment-notification-modal modal-text-bold notification-footer'}
                        />
                        {isReadAndWrite &&
                        <div className="tooltip-container">
                            <div className="btn-tooltiptext">
                                <Button
                                    className='save-details-btn btn btn-primary'
                                    disabled={isProcessing || initialRowKeysCount == 0}
                                    onClick={this.handleGenerateOutputRecord}
                                    type="button"
                                >
                                    Generate Output Record
                                </Button>
                                <div className="save-tooltip-text-container">
                                    <span className="tooltip-text-save start-50 translate-middle-x mx-0 top--70">
                                        {this.toLocaleLanguage("generate_output_record", false)}
                                    </span>
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(connect(
    state => {
        const { outputConfigRechargeItems, appSettings } = state;
        return {
            outputConfigRechargeItems,
            translation,
            locale: appSettings?.locale || 'en'
        };
    },
    dispatch => bindActionCreators(
        { ...outputConfigRechargeItemsActions },
        dispatch
    )
)(RechargeItems));
